import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpActivityStateLabel
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * Displaying the label based on the status of an activity (i.e. WON).
     *
     * @param {string} state
     * @param {string} type
     * @param {string?} displayMode Can be `'icon'` or `'text'`. Defaults to `'text'`.
     * @param {string?} context Can be `'statusDisplay'` (used to mimic new platform's react status component)
     *
     * @author damazzot.btc
     */
    angular
        .module('app')
        .directive('pkpActivityStateLabel', pkpActivityStateLabel);

    function pkpActivityStateLabel() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                state: '=',
                type: '=',
                displayMode: '=?',
                context: '@'
            },
            template:
                require('app/_directives/pkp-activity-state-label.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            if (!scope.displayMode) {
                scope.displayMode = 'text';
            }

            if (!scope.type) {
                scope.type = 'default';
            }
        }
    }
})();
